
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ssp/orders",
      function () {
        return require("private-next-pages/ssp/orders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ssp/orders"])
      });
    }
  